<template>
  <v-data-table
    :headers="headers"
    :items="alertList"
    :loading="isLoading"
    :search="search"
    :pagination.sync="pagination"
    class="elevation-1"
  >
    <template slot="items" slot-scope="props">
      <td>{{ formatEpochTime(props.item.time) }}</td>
      <td style="text-align:center;" class="text-xs-right">{{ props.item.formName }}</td>
      <td style="text-align:center;" class="text-xs-right">{{ props.item.submissionId }}</td>
      <td style="text-align:center;" class="text-xs-right">{{ props.item.alertTarget }}</td>
      <td style="text-align:center;" class="text-xs-right">{{ props.item.emailSent }}</td>
      <td style="text-align:center;" class="text-xs-right">{{ props.item.email }}</td>
      <td style="text-align:center;" class="text-xs-right">{{ props.item.alertMessages }}</td>
      <td style="text-align:center;" class="text-xs-right">
        <alertTableOptions
          :submissionId="props.item.submissionId"
          :formName="props.item.formName"
          :emailAddress="props.item.email"
          :alertMessages="props.item.alertMessages"
          @popUpRequest1="popUpRequest2"
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import alertTableOptions from "../alertTableOptions.vue";
const formatTime = require("../../helpers/formatHelpers.js").formatTime;
export default {
  name: "AlertsTable",
  components: { alertTableOptions },
  props: {
    alertList: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      headers: [
        {
          text: "Time",
          value: "time"
        },
        {
          text: "Form Name",
          value: "formName",
          align: "right"
        },
        {
          text: "Submission ID",
          value: "submissionId",
          align: "right"
        },
        {
          text: "Alert Target",
          value: "alertTarget",
          align: "right"
        },
        {
          text: "Email Sent?",
          value: "emailSent",
          align: "right"
        },
        {
          text: "Email",
          value: "email",
          align: "right"
        },
        {
          text: "Alert Messages",
          value: "alertMessages",
          align: "right"
        },
        {
          text: "Options",
          value: "options",
          align: "right"
        }
      ],
      pagination: {
        sortBy: "time"
      }
    };
  },
  methods: {
    formatEpochTime(formatEpochTime) {
      return formatTime(formatEpochTime);
    },
    popUpRequest2(payload) {
      this.$emit('popUpRequest2', payload)
      if (payload.actionType === 'Delete') 
        this.$emit('deleteRequest', payload.submissionId)
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/tables/AlertsTable.vue